export type CanonicalBar = {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
};

export function normalizeUnixSeconds(rawTime: unknown): number {
  const numeric = Number(rawTime);
  if (Number.isFinite(numeric)) {
    return numeric > 1e12 ? Math.floor(numeric / 1000) : Math.floor(numeric);
  }

  return Math.floor(new Date(rawTime as any).getTime() / 1000);
}

export function normalizeBars(raw: any[]): CanonicalBar[] {
  if (!Array.isArray(raw)) return [];

  const out: CanonicalBar[] = raw.map((b) => {
    const rawTime = b?.t ?? b?.time ?? b?.timestamp;
    const time = normalizeUnixSeconds(rawTime);
    if (!Number.isFinite(time)) {
      throw new Error('Invalid timestamp in ChartDataAdapter');
    }

    const open = Number(b?.o ?? b?.open);
    const high = Number(b?.h ?? b?.high);
    const low = Number(b?.l ?? b?.low);
    const close = Number(b?.c ?? b?.close);
    const volumeRaw = Number(b?.v ?? b?.volume);

    if (!Number.isFinite(open) || !Number.isFinite(high) || !Number.isFinite(low) || !Number.isFinite(close)) {
      throw new Error('Invalid OHLC value in ChartDataAdapter');
    }

    return {
      time,
      open,
      high,
      low,
      close,
      ...(Number.isFinite(volumeRaw) ? { volume: volumeRaw } : {}),
    };
  });

  return out.sort((a, b) => a.time - b.time);
}
